export default {
  mounted(el) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('section-visible')
          el.classList.add('animate')
          observer.unobserve(el)
        }
      },
      { threshold: 0.2 } // when x% of the element is visible
    )
    observer.observe(el)
  },
}
